@if (orders && orders.length > 0) {
  <div class="orders">
      <h2>{{ 'locker.cart.orders' | translate }}</h2>
      <p>{{ 'locker.cart.orders_info' | translate }}</p>

      <!-- Pedidos pendientes -->
      <div class="orders-card">
          <div class="orders-card-header" (click)="pendingCollapsed = (pendingOrders.length == 0 ? true : !pendingCollapsed)">
              <div class="orders-card-header-title">
                  <div>
                      <h5>{{ 'locker.cart.status_pending_plural' | translate }}</h5>
                      @if (pendingOrders.length > 0) {
                          <span class="background-primary">{{ pendingOrders.length }}</span>
                      }
                  </div>
                  <small>{{ 'locker.cart.status_pending_description' | translate }}</small>
              </div>
              @if (pendingOrders.length > 0) {
                  <button mat-icon-button [class.rotated]="pendingCollapsed"><mat-icon>expand_more</mat-icon></button>
              }
          </div>
          <div class="orders-card-body" [class.collapsed]="pendingCollapsed">
            @for (order of pendingOrders; track order) {
              <div class="item">
                  <app-locker-order [order]="order" [menu]="menu"></app-locker-order>
              </div>
            }
          </div>
      </div>

      <!-- Pedidos pagados -->
      <div class="orders-card">
          <div class="orders-card-header" (click)="paidCollapsed = (paidOrders.length == 0 ? true : !paidCollapsed)">
              <div class="orders-card-header-title">
                  <div>
                      <h5>{{ 'locker.cart.status_paid_plural' | translate }}</h5>
                      @if (paidOrders.length > 0) {
                          <span class="background-primary">{{ paidOrders.length }}</span>
                      }
                  </div>
                  <small>{{ 'locker.cart.status_paid_description' | translate }}</small>
              </div>
              @if (paidOrders.length > 0) {
                  <button mat-icon-button [class.rotated]="paidCollapsed"><mat-icon>expand_more</mat-icon></button>
              }
          </div>
          <div class="orders-card-body" [class.collapsed]="paidCollapsed">
            @for (order of paidOrders; track order) {
              <div class="item">
                  <app-locker-order [order]="order" [menu]="menu"></app-locker-order>
              </div>
            }
          </div>
      </div>

      <!-- Pedidos entregados -->
      <div class="orders-card">
          <div class="orders-card-header" (click)="deliveredCollapsed = (deliveredOrders.length == 0 ? true : !deliveredCollapsed)">
              <div class="orders-card-header-title">
                  <div>
                      <h5>{{ 'locker.cart.status_delivered_plural' | translate }}</h5>
                      @if (deliveredOrders.length > 0) {
                          <span class="background-primary">{{ deliveredOrders.length }}</span>
                      }
                  </div>
                  <small>{{ 'locker.cart.status_delivered_description' | translate }}</small>
              </div>            
              @if (deliveredOrders.length > 0) {
                  <button mat-icon-button [class.rotated]="deliveredCollapsed"><mat-icon>expand_more</mat-icon></button>
              }
          </div>
          <div class="orders-card-body" [class.collapsed]="deliveredCollapsed">
            @for (order of deliveredOrders; track order) {
              <div class="item">
                  <app-locker-order [order]="order" [menu]="menu"></app-locker-order>
              </div>
            }
          </div>
      </div>

      <!-- Pedidos cancelados -->
      <div class="orders-card">
          <div class="orders-card-header" (click)="cancelledCollapsed = (cancelledOrders.length == 0 ? true : !cancelledCollapsed)">
              <div class="orders-card-header-title">
                  <div>
                      <h5>{{ 'locker.cart.status_cancelled_plural' | translate }}</h5>
                      @if (cancelledOrders.length > 0) {
                          <span class="background-primary">{{ cancelledOrders.length }}</span>
                      }
                  </div>
                  <small>{{ 'locker.cart.status_cancelled_description' | translate }}</small>
              </div>
              @if (cancelledOrders.length > 0) {
                  <button mat-icon-button [class.rotated]="cancelledCollapsed"><mat-icon>expand_more</mat-icon></button>
              }
          </div>
          <div class="orders-card-body" [class.collapsed]="cancelledCollapsed">
            @for (order of cancelledOrders; track order) {
              <div class="item">
                  <app-locker-order [order]="order" [menu]="menu"></app-locker-order>
              </div>
            }
          </div>
      </div>
  </div>
}

@if (!orders || orders.length == 0) {
  <div class="orders">
      <h2>{{ 'locker.cart.orders' | translate }}</h2>
      <p>{{ 'locker.cart.orders_empty' | translate }}</p>
  </div>
}